/* Native media/variant/zoom behavior retained; desktop thumbnail navigation added. */
if(!customElements.get('as-archive-gallery'))customElements.define('as-archive-gallery',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();this.desktop=matchMedia('(min-width:1000px)');
  const signal=this.abort.signal;
  this.addEventListener('click',e=>{
   if(!this.desktop.matches)return;
   const thumb=e.target.closest('[data-archive-target]');
   if(thumb){e.preventDefault();e.stopImmediatePropagation();this.jump(thumb.dataset.archiveTarget);return;}
   // Grid images use their native zoom controls, never carousel next/previous.
   if(e.target.closest('.product-gallery__media')&&!e.target.closest('button,a,video,model-viewer,video-media,external-video'))e.stopImmediatePropagation();
  },{capture:true,signal});
  this.desktop.addEventListener('change',()=>this.observe(),{signal});
  this.observe();
  const gallery=this.querySelector('product-gallery'),form=document.getElementById(gallery?.getAttribute('form'));
  form?.addEventListener('variant:change',e=>{
   if(!this.desktop.matches)return;
   const next=e.detail.variant?.featured_media,prev=e.detail.previousVariant?.featured_media;
   if(next&&next.id!==prev?.id){const media=[...this.querySelectorAll('[data-media-id]')].find(x=>x.dataset.mediaId===String(next.id));if(media&&!media.hidden)this.jump(media.id,false);}
  },{signal});
  this.mutations=new MutationObserver(()=>this.observe());this.mutations.observe(this,{subtree:true,attributes:true,attributeFilter:['hidden']});
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.mutations?.disconnect()}
 jump(id,smooth=true){const target=document.getElementById(id);if(!target||target.hidden)return;target.scrollIntoView({block:'start',behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});this.mark(id)}
 mark(id){this.querySelectorAll('[data-archive-target]').forEach(b=>b.setAttribute('aria-current',String(b.dataset.archiveTarget===id)))}
 observe(){this.observer?.disconnect();if(!this.desktop.matches)return;
  const items=[...this.querySelectorAll('.product-gallery__media:not([hidden])')];
  this.observer=new IntersectionObserver(entries=>{const point=innerHeight*.4;const current=items.find(x=>{const r=x.getBoundingClientRect();return r.top<=point&&r.bottom>point});if(current)this.mark(current.id)},{rootMargin:'-20% 0px -50% 0px',threshold:0});items.forEach(x=>this.observer.observe(x));
 }
});
